"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CartItems = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const cart_items_1 = require("../styles/cart-items");
const hooks_1 = require("../utils/hooks");
const cart_item_1 = __importDefault(require("./cart-item"));
const loyalty_cart_item_1 = __importDefault(require("./loyalty-cart-item"));
const CartItems = ({ groups, loyalty, isExpired, onRouting, cartType }) => {
    const { i18n } = (0, hooks_1.useTranslate)();
    const title = isExpired ? i18n('cart_widget.expired.title') : i18n('cart_widget.reserved');
    return ((0, jsx_runtime_1.jsxs)(cart_items_1.HiddenScrollbarParent, { children: [(0, jsx_runtime_1.jsx)(cart_items_1.Title, { children: title }), loyalty && (0, jsx_runtime_1.jsx)(loyalty_cart_item_1.default, { item: loyalty, isExpired: isExpired, cartType: cartType }), groups === null || groups === void 0 ? void 0 : groups.map((group) => ((0, jsx_runtime_1.jsx)(cart_items_1.CampaignGroup, { children: group.items.map((item) => item && (0, jsx_runtime_1.jsx)(cart_item_1.default, { item: item, isExpired: isExpired, onRouting: onRouting, cartType: cartType }, item.product_id)) }, group.group_id)))] }));
};
exports.CartItems = CartItems;
exports.default = exports.CartItems;
